import { logFactory } from '../../util'
import { useQuery } from 'react-query'
import { useConsultantsService, useUsersService } from 'hooks/services'

const hookName = 'useConsultantUser'
const log = logFactory(hookName)

const useConsultantUser = (enabled = true) => {
  const { getMe } = useUsersService()
  const { getConsultant, isReady } = useConsultantsService()

  const doQuery = async () => {
    log(`⭐️ Fetching a consultant...`)

    const user = await getMe()
    if (!user?.relatedEntityGids?.consultantGid) {
      log(`⭐️ No consultant found for user...`, { user })
      return null
    }

    const consultant = await getConsultant(user?.relatedEntityGids?.consultantGid)

    log(`⭐️ Returned consultant...`, { consultant, consultantGid: user?.relatedEntityGids?.consultantGid })

    return consultant
  }

  const {
    data: consultant,
    isError,
    isLoading,
  } = useQuery([hookName], doQuery, {
    enabled: isReady && enabled,
  })

  return {
    consultant,
    isError,
    isLoading: !isReady || isLoading,
  }
}

export { useConsultantUser, hookName as useConsultantUserHookName }
